import { render } from "./i-options.vue?vue&type=template&id=f4bbf36a&scoped=true"
import script from "./i-options.vue?vue&type=script&lang=js"
export * from "./i-options.vue?vue&type=script&lang=js"

import "./i-options.vue?vue&type=style&index=0&id=f4bbf36a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4bbf36a"]])

export default __exports__